var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sr-eye-open",
    clipPath: "url(#clip0_5725_8959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04948 6C8.04948 7.26565 7.02346 8.29167 5.75781 8.29167C4.49216 8.29167 3.46615 7.26565 3.46615 6C3.46615 4.73435 4.49216 3.70833 5.75781 3.70833C7.02346 3.70833 8.04948 4.73435 8.04948 6ZM7.13281 6C7.13281 6.75939 6.5172 7.375 5.75781 7.375C4.99842 7.375 4.38281 6.75939 4.38281 6C4.38281 5.24061 4.99842 4.625 5.75781 4.625C6.5172 4.625 7.13281 5.24061 7.13281 6Z",
    fill: "#5801FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2578 6C11.2578 7.14583 8.79538 10.125 5.75781 10.125C2.72025 10.125 0.257812 7.375 0.257812 6C0.257812 4.625 2.72025 1.875 5.75781 1.875C8.79538 1.875 11.2578 4.85417 11.2578 6ZM10.3409 5.99951L10.341 6L10.3409 6.00049C10.3398 6.00956 10.333 6.06642 10.2901 6.17811C10.243 6.30115 10.165 6.45729 10.0507 6.63825C9.82177 7.00049 9.47622 7.41599 9.03663 7.80819C8.14616 8.60268 6.97925 9.20833 5.75781 9.20833C4.51443 9.20833 3.34402 8.64086 2.46779 7.8843C2.03328 7.50912 1.69427 7.10658 1.4702 6.74335C1.23354 6.3597 1.17448 6.10156 1.17448 6C1.17448 5.89844 1.23354 5.6403 1.4702 5.25665C1.69427 4.89342 2.03328 4.49088 2.46779 4.1157C3.34402 3.35914 4.51443 2.79167 5.75781 2.79167C6.97925 2.79167 8.14616 3.39732 9.03663 4.19181C9.47622 4.58401 9.82177 4.99951 10.0507 5.36175C10.165 5.54271 10.243 5.69885 10.2901 5.82189C10.333 5.93358 10.3398 5.99044 10.3409 5.99951Z",
    fill: "#5801FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5725_8959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0.257812 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewEye);
export default __webpack_public_path__ + "static/media/view_eye.03d49dd0f50e0ce31eeb1fbab6ee1ae0.svg";
export { ForwardRef as ReactComponent };